import { SHIP_IT, PICK_UP, SAME_DAY } from '../consts/fulfillment';

export const calculateBopsAvailabilityMap = ({ availabilityData, upcData, selectedRadioButton }) => {
  const availabilityMap = {};
  const upcNumberBopsMap = availabilityData?.upcNumberBopsMap || {};
  const upcNumberSddMap = availabilityData?.upcNumberSddMap || {};

  Object.entries(upcData?.upcs || {}).forEach(([upcDictionaryKey, upc]) => {
    const upcNumber = upc?.number;
    const bopsDataForUpc = upcNumberBopsMap[upcNumber] || upcNumberBopsMap[+upcNumber];
    const sddDataForUpc = upcNumberSddMap[upcNumber] || upcNumberSddMap[+upcNumber];

    if (bopsDataForUpc || sddDataForUpc) {
      // 1. Determine home delivery availability: must have deliveryType with deliveryCode "G"
      const isShippableToHome =
        Array.isArray(bopsDataForUpc?.deliveryTypes) && bopsDataForUpc.deliveryTypes.some((type) => type.deliveryCode === 'G');

      // 2. Extract pickup and fulfillment eligibilities
      const bopsAvailObj = bopsDataForUpc?.availability || {};
      const isBopsAvailable = !!bopsAvailObj.bopsAvailability;
      const isBossAvailable = !!bopsAvailObj.bossAvailability;
      const isPickupAvailable = isBopsAvailable || isBossAvailable;

      const isSddAvailable = !!sddDataForUpc?.sddAvailability;

      let available = isShippableToHome;
      let bopsAvailability = isBopsAvailable;

      if (selectedRadioButton === PICK_UP) {
        available = false;
        bopsAvailability = isPickupAvailable;
      } else if (selectedRadioButton === SAME_DAY) {
        available = isSddAvailable;
        bopsAvailability = false;
      } else if (selectedRadioButton === SHIP_IT) {
        available = isShippableToHome;
        bopsAvailability = false;
      }

      availabilityMap[upcDictionaryKey] = {
        available,
        bopsAvailability,
        bossAvailability: isBossAvailable,
        storeAvailability: !!bopsAvailObj.storeAvailability,
        isAnyFulfillmentAvailable: Boolean(isShippableToHome || isPickupAvailable || isSddAvailable),
      };
    } else {
      // If the UPC is missing entirely from the response, it is completely unavailable.
      availabilityMap[upcDictionaryKey] = {
        available: false,
        bopsAvailability: false,
        bossAvailability: false,
        storeAvailability: false,
        isAnyFulfillmentAvailable: false,
      };
    }
  });

  return availabilityMap;
};
